import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_Transition, { name: "latest" }, {
    default: _withCtx(() => [
      ($props.visible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["down-button", {generating: $props.generating}]),
            "aria-label": 'Scroll to latest message' + ($props.generating ? ', response in progress' : ''),
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('scroll')))
          }, [
            ($props.generating)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  icon: "animated/thinking-asterisk",
                  class: "thinking",
                  width: "1.6rem",
                  height: "1.6rem",
                  external: ""
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_Icon, {
              icon: "arrow-down",
              class: "arrow",
              size: "1.6rem",
              stroke: "var(--brand-700)"
            })
          ], 10 /* CLASS, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}